import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { ArrowDropUp } from '@mui/icons-material';
import styled from 'styled-components';
import { PageTitle } from '../../components/StyledComponents';

const Container = styled.div``;
const Item = styled.div`
	width: 100%;
	max-width: 460px;
	height: 225px;
	box-shadow: 0px 5px 8px rgba(0, 0, 0, 0.32);
	border-radius: 0.125rem;
	padding: 0.75rem;
	background-color: #E6E6E690;
	cursor: pointer;
`;
const Image = styled.img``;

const cardStyle = {
	box: {
		backgroundColor: '#FFFFFF',
		height: '100%',
		padding: '0.5rem',
		display: 'flex',
		flexDirection: 'column',
		// justifyContent: 'center'
	},
	titleSmall: {
		color: 'rgba(0, 0, 0, 0.45)',
		fontSize: '1.25rem',
	},
	titleLarge: {
		fontWeight: 700,
		fontSize: '2.5rem',
		color: 'rgba(0, 0, 0, 0.85)'
	},
	titleBox: {
		display: 'flex',
		alignItems: 'center'
	},
	subTitle: {
		fontSize: '1.25rem',
	},
	icon: {
		color: '#52C41A',
		fontSize: '2.5rem',
	},
	footer: {
		marginTop: '0.5rem',
		fontSize: '0.875rem'
	}
}

export const Cards = () => {
	return (
		<Grid container spacing={4}>
				<Grid item xs={12} sm={6} md={4} lg={3}>
					<Item>
						<Box sx={cardStyle.box}>
							<Typography sx={cardStyle.titleSmall} variant='button'>Contributors</Typography>
							<Typography sx={cardStyle.titleLarge}>126,560</Typography>
							<Box sx={cardStyle.titleBox}>
								<Typography sx={cardStyle.subTitle}>Active Users</Typography>
								<ArrowDropUp sx={cardStyle.icon} />
							</Box>
						</Box>
					</Item>
				</Grid>
				<Grid item xs={12} sm={6} md={4} lg={3}>
					<Item>
						<Box sx={cardStyle.box}>
							<Typography sx={cardStyle.titleSmall} variant='button'>transactions</Typography>
							<Typography sx={cardStyle.titleLarge}>8,846</Typography>
							<Image src="/assets/trx-chart.svg" alt="trx" />
							<Typography sx={cardStyle.footer}>Daily visits: 1,234</Typography>
						</Box>
					</Item>
				</Grid>
				<Grid item xs={12} sm={6} md={4} lg={3}>
					<Item>
						<Box sx={cardStyle.box}>
							<Typography sx={cardStyle.titleSmall} variant='button'>active loans</Typography>
							<Typography sx={cardStyle.titleLarge}>126,560</Typography>
							<Image src="/assets/loans-chart.svg" alt="loans" />
							<Typography sx={cardStyle.footer}>Conversion Rate: 60%</Typography>
						</Box>
					</Item>
				</Grid>
				<Grid item xs={12} sm={6} md={4} lg={3}>
					<Item>
						<Box sx={cardStyle.box}>
							<Typography sx={cardStyle.titleSmall} variant='button'>Marketers</Typography>
							<Typography sx={cardStyle.titleLarge}>6,560</Typography>
							<Image src="/assets/loans-chart.svg" alt="marketers" />
							<Typography sx={cardStyle.footer}>Conversion Rate: 60%</Typography>
						</Box>
					</Item>
				</Grid>
			</Grid>
	)
}

const Audit = () => {
	return (
		<Container>
			<PageTitle>Auditing</PageTitle>
			<Cards />
		</Container>		
	)
}

export default Audit;